import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FacebookIcon from '@mui/icons-material/Facebook';

import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Link from '@mui/material/Link';
import MailIcon from '@mui/icons-material/Mail';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PendingIcon from '@mui/icons-material/HourglassEmpty';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import BurgerBar from '../Materials/BurgerBar';


export default function EntityDetailsPage() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);
  const { id } = useParams(); // Captura o ID da entidade da URL
  const [entity, setEntity] = useState(null);
  const [projects, setProjects] = useState([]);
  const [patents, setPatents] = useState([]);
  const [skills, setSkills] = useState([]); // Para armazenar as skills
  const [researchAreas, setResearchAreas] = useState({}); // Para armazenar as descrições das áreas de pesquisa
  const [equipments, setEquipments] = useState([]); // Para armazenar os equipamentos
  const [entitiesMap, setEntitiesMap] = useState({}); // Para mapear entity_id -> entity_name
  const [categoriesMap, setCategoriesMap] = useState({}); // Para mapear category_id -> category_name
  const [processTypesMap, setProcessTypesMap] = useState({}); // Para mapear category_id -> category_name
  const [filteredEquipments, setFilteredEquipments] = useState([]); // Para armazenar os equipamentos filtrados
  const [activeFilter, setActiveFilter] = useState(null); // Para controlar o filtro ativo ("Food Analysis" ou "Food Technologies")
  const [isLoading, setIsLoading] = useState(false); // Para controlar o estado de carregamento
  const [error, setError] = useState(null); // Para armazenar erros
  const [matrices, setMatrices] = useState([]); // Para armazenar as matrizes
  const [matricesCategories, setMatricesCategories] = useState([]); // Para armazenar as categorias das matrizes
  const [matricesSubcategories, setMatricesSubcategories] = useState([]); // Para armazenar as subcategorias das matrizes
  const [expandedAll, setExpandedAll] = useState(false); // Para controlar o estado de "Expand All"
  const [isLoadingEquipments, setIsLoadingEquipments] = useState(false);
  const [errorEquipments, setErrorEquipments] = useState(null);

  const [isLoadingMatrices, setIsLoadingMatrices] = useState(false);
  const [errorMatrices, setErrorMatrices] = useState(null);

  const [isLoadingSkills, setIsLoadingSkills] = useState(false);
  const [errorSkills, setErrorSkills] = useState(null);

  const [subEntities, setSubEntities] = useState([]); // Para armazenar as subentidades
  const [investigationGroups, setInvestigationGroups] = useState([]); // Para armazenar os grupos de investigação

  const [isLoadingEntity, setIsLoadingEntity] = useState(false);
  const [errorEntity, setErrorEntity] = useState(null);

  const [isLoadingFaculty, setIsLoadingFaculty] = useState(false);
  const [errorFaculty, setErrorFaculty] = useState(null);

  const [isLoadingProjects, setIsLoadingProjects] = useState(false);
  const [errorProjects, setErrorProjects] = useState(null);

  const [isLoadingPatents, setIsLoadingPatents] = useState(false);
  const [errorPatents, setErrorPatents] = useState(null);

  // Estados específicos para Subentidades
  const [isLoadingSubEntities, setIsLoadingSubEntities] = useState(false);
  const [errorSubEntities, setErrorSubEntities] = useState(null);

  // Estados específicos para Grupos de Investigação
  const [isLoadingInvestigationGroups, setIsLoadingInvestigationGroups] = useState(false);
  const [errorInvestigationGroups, setErrorInvestigationGroups] = useState(null);

  const [openEquipmentDetails, setOpenEquipmentDetails] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [equipmentDetails, setEquipmentDetails] = useState(null);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const toggleExpandItem = (index) => {
    if (expandedItems.includes(index)) {
      setExpandedItems(expandedItems.filter((item) => item !== index)); // Recolhe o item
    } else {
      setExpandedItems([...expandedItems, index]); // Expande o item
    }
  };

  const toggleExpandAll = () => {
    if (expandedAll) {
      setExpandedItems([]); // Recolhe todos os itens
    } else {
      setExpandedItems(matrices.map((_, index) => index)); // Expande todos os itens
    }
    setExpandedAll(!expandedAll); // Alterna o estado de "Expand All"
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const handleExit = () => {
    navigate('/');
  };

  const handleTopicClick = (topic) => {
    setSelectedTopic(topic);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedTopic(null);
  };

  // Função para abrir o popup e buscar os detalhes do equipamento
const handleOpenEquipmentDetails = async (equipment) => {
  setSelectedEquipment(equipment);
  setOpenEquipmentDetails(true);

  try {
    // Busca os detalhes do equipamento
    const response = await fetch(`https://api.hub4food.colab4food.com/api/equipments/${equipment.id}`);
    if (!response.ok) {
      throw new Error('Erro ao buscar os detalhes do equipamento');
    }
    const data = await response.json();

    // Busca os nomes das entidades, categorias e tipos de processo
    const entityName = entitiesMap[data.entity_id] || 'N.A';
    const categoryName = categoriesMap[data.category_id] || 'N.A';
    const processTypeName = processTypesMap[data.process_type] || 'N.A';

    // Inicializa as observações da matriz como "Carregando..."
    let matriceObservations = 'N.A';

    // Se houver matrice_id, busca as observações da matriz
    if (data.matrice_id) {
      try {
        const matriceResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrices/${data.matrice_id}`);
        if (!matriceResponse.ok) {
          throw new Error('Erro ao buscar as observações da matriz');
        }
        const matriceData = await matriceResponse.json();
        matriceObservations = matriceData.observations || 'Sem informações';
      } catch (error) {
        console.error('Erro ao buscar as observações da matriz:', error);
        matriceObservations = 'Erro ao carregar informações';
      }
    }

    // Atualiza os detalhes do equipamento com os nomes e observações da matriz
    setEquipmentDetails({
      ...data,
      entityName,
      categoryName,
      processTypeName,
      matriceObservations, // Adiciona as observações da matriz
    });
  } catch (error) {
    console.error('Erro ao buscar os detalhes do equipamento:', error);
    setEquipmentDetails({
      entityName: 'N.A',
      categoryName: 'N.A',
      processTypeName: 'N.A',
      matriceObservations: 'Erro ao carregar informações',
    });
  }
};

// Função para fechar o popup
const handleCloseEquipmentDetails = () => {
  setOpenEquipmentDetails(false);
  setSelectedEquipment(null);
  setEquipmentDetails(null);
};

  useEffect(() => {
    const fetchEntityDetails = async () => {
      if (!id) return;
      setIsLoadingEntity(true); // Usar o estado específico para Entity Details
      setErrorEntity(null); // Usar o estado específico para Entity Details
  
      try {
        const response = await fetch(`https://api.hub4food.colab4food.com/api/entities/${id}`);
        if (!response.ok) {
          if (response.status === 404) {
            setEntity(null);
            setErrorEntity("Nenhum detalhe da entidade encontrado."); // Mensagem específica
          } else {
            throw new Error('Erro ao buscar os detalhes da entidade');
          }
        } else {
          const data = await response.json();
          setEntity(data);
        }
      } catch (error) {
        setErrorEntity(error.message); // Usar o estado específico para Entity Details
      } finally {
        setIsLoadingEntity(false); // Usar o estado específico para Entity Details
      }
    };
  
    fetchEntityDetails();
  }, [id]);

  useEffect(() => {
    const fetchProjects = async () => {
      if (!id) return;
      setIsLoadingProjects(true); // Usar o estado específico para Projects
      setErrorProjects(null); // Usar o estado específico para Projects
  
      try {
        const response = await fetch(`https://api.hub4food.colab4food.com/api/projects/entity/${id}`);
        if (!response.ok) {
          if (response.status === 404) {
            setProjects([]);
            setErrorProjects("Nenhum projeto encontrado."); // Mensagem específica
          } else {
            throw new Error('Erro ao buscar os projetos');
          }
        } else {
          const data = await response.json();
          setProjects(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        setErrorProjects(error.message); // Usar o estado específico para Projects
      } finally {
        setIsLoadingProjects(false); // Usar o estado específico para Projects
      }
    };
  
    fetchProjects();
  }, [id]);

  useEffect(() => {
    const fetchPatents = async () => {
      if (!id) return;
      setIsLoadingPatents(true); // Usar o estado específico para Patents
      setErrorPatents(null); // Usar o estado específico para Patents
  
      try {
        const response = await fetch(`https://api.hub4food.colab4food.com/api/patents/entity/${id}`);
        if (!response.ok) {
          if (response.status === 404) {
            setPatents([]);
            setErrorPatents("Nenhuma patente encontrada."); // Mensagem específica
          } else {
            throw new Error('Erro ao buscar as patentes');
          }
        } else {
          const data = await response.json();
          setPatents(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        setErrorPatents(error.message); // Usar o estado específico para Patents
      } finally {
        setIsLoadingPatents(false); // Usar o estado específico para Patents
      }
    };
  
    fetchPatents();
  }, [id]);

  useEffect(() => {
    const fetchSkillsAndResearchAreas = async () => {
      if (!id) return;
      setIsLoadingSkills(true); // Usar o estado específico para skills
      setErrorSkills(null); // Usar o estado específico para skills

      try {
        // Busca as skills da entidade
        const skillsResponse = await fetch(`https://api.hub4food.colab4food.com/api/skills/entity/${id}`);
        if (!skillsResponse.ok) {
          if (skillsResponse.status === 404) {
            setSkills([]);
            setErrorSkills("Nenhuma skill encontrada."); // Mensagem específica para skills
          } else {
            throw new Error('Erro ao buscar as skills');
          }
        } else {
          const skillsData = await skillsResponse.json();
          setSkills(Array.isArray(skillsData) ? skillsData : []);
        }

        // Busca as áreas de pesquisa
        const researchAreasResponse = await fetch(`https://api.hub4food.colab4food.com/api/research-areas-fields`);
        if (!researchAreasResponse.ok) {
          throw new Error('Erro ao buscar as áreas de pesquisa');
        }
        const researchAreasData = await researchAreasResponse.json();

        // Cria um objeto para mapear research_areas_field_id -> description
        const researchAreasMap = researchAreasData.reduce((acc, area) => {
          acc[area.id] = area.description;
          return acc;
        }, {});

        // Atualiza o estado das áreas de pesquisa
        setResearchAreas(researchAreasMap);
      } catch (error) {
        setErrorSkills(error.message); // Usar o estado específico para skills
      } finally {
        setIsLoadingSkills(false); // Usar o estado específico para skills
      }
    };

    fetchSkillsAndResearchAreas();
  }, [id]);

  useEffect(() => {
    const fetchEquipmentsAndRelatedData = async () => {
      if (!id) return;
      setIsLoadingEquipments(true); // Usar o estado específico para equipamentos
      setErrorEquipments(null); // Usar o estado específico para equipamentos

      let equipmentsData = [];

      try {
        // Busca os equipamentos da entidade
        const equipmentsResponse = await fetch(`https://api.hub4food.colab4food.com/api/equipments/entity/${id}`);
        if (!equipmentsResponse.ok) {
          if (equipmentsResponse.status === 404) {
            setEquipments([]);
            setErrorEquipments("Nenhum equipamento encontrado."); // Mensagem específica para equipamentos
          } else {
            throw new Error('Erro ao buscar os equipamentos');
          }
        } else {
          equipmentsData = await equipmentsResponse.json();
          setEquipments(Array.isArray(equipmentsData) ? equipmentsData : []);
        }

        // Busca todas as entidades
        const entitiesResponse = await fetch(`https://api.hub4food.colab4food.com/api/entities`);
        if (!entitiesResponse.ok) {
          throw new Error('Erro ao buscar as entidades');
        }
        const entitiesData = await entitiesResponse.json();

        // Busca todas as categorias
        const categoriesResponse = await fetch(`https://api.hub4food.colab4food.com/api/categories`);
        if (!categoriesResponse.ok) {
          throw new Error('Erro ao buscar as categorias');
        }
        const categoriesData = await categoriesResponse.json();

        // Busca todos os tipos de processo
      const processTypesResponse = await fetch(`https://api.hub4food.colab4food.com/api/process-types`);
      if (!processTypesResponse.ok) {
        throw new Error('Erro ao buscar os tipos de processo');
      }
      const processTypesData = await processTypesResponse.json();

        // Cria um objeto para mapear entity_id -> entity_name
        const entitiesMap = entitiesData.reduce((acc, entity) => {
          acc[entity.id] = entity.name;
          return acc;
        }, {});

        // Cria um objeto para mapear category_id -> category_name
        const categoriesMap = categoriesData.reduce((acc, category) => {
          acc[category.id] = category.category_name;
          return acc;
        }, {});

        // Cria um objeto para mapear process_type_id -> process_type_name
      const processTypesMap = processTypesData.reduce((acc, processType) => {
        acc[processType.id] = processType.description; // Supondo que o campo seja "description"
        return acc;
      }, {});
      // Busca todas as matrizes
      const matricesResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrices`);
      if (!matricesResponse.ok) {
        throw new Error('Erro ao buscar as matrizes');
      }
      const matricesData = await matricesResponse.json();
 
      // Cria um objeto para mapear matrice_id -> observations
      const matricesMap = matricesData.reduce((acc, matrix) => {
        acc[matrix.id] = matrix.observations;
        return acc;
      }, {});
 
      // Adiciona as observações das matrizes aos equipamentos
      const equipmentsWithMatrices = equipmentsData.map((equipment) => ({
        ...equipment,
        matriceObservations: matricesMap[equipment.matrice_id] || 'N.A',
      }));
 
      setEquipments(equipmentsWithMatrices);
      setFilteredEquipments(equipmentsWithMatrices);
 
  
  

        // Atualiza os estados
      setEntitiesMap(entitiesMap);
      setCategoriesMap(categoriesMap);
      setProcessTypesMap(processTypesMap);
      setFilteredEquipments(Array.isArray(equipmentsData) ? equipmentsData : []);
    } catch (error) {
      setErrorEquipments(error.message);
    } finally {
      setIsLoadingEquipments(false);
    }
  };

    fetchEquipmentsAndRelatedData();
  }, [id]);

  useEffect(() => {
    const fetchMatricesAndRelatedData = async () => {
      if (!id) return;
      setIsLoadingMatrices(true); // Usar o estado específico para matrices
      setErrorMatrices(null); // Usar o estado específico para matrices

      try {
        // Busca as matrizes da entidade
        const matricesResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrices/entity/${id}`);
        if (!matricesResponse.ok) {
          if (matricesResponse.status === 404) {
            setMatrices([]);
            setErrorMatrices("Nenhuma matriz encontrada."); // Mensagem específica para matrices
          } else {
            throw new Error('Erro ao buscar as matrizes');
          }
        } else {
          const matricesData = await matricesResponse.json();
          setMatrices(Array.isArray(matricesData) ? matricesData : []);
        }

        // Busca todas as categorias das matrizes
        const categoriesResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrice-categories`);
        if (!categoriesResponse.ok) {
          throw new Error('Erro ao buscar as categorias das matrizes');
        }
        const categoriesData = await categoriesResponse.json();

        // Busca todas as subcategorias das matrizes
        const subcategoriesResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrice-subcategories`);
        if (!subcategoriesResponse.ok) {
          throw new Error('Erro ao buscar as subcategorias das matrizes');
        }
        const subcategoriesData = await subcategoriesResponse.json();

        // Atualiza os estados
        setMatricesCategories(Array.isArray(categoriesData) ? categoriesData : []);
        setMatricesSubcategories(Array.isArray(subcategoriesData) ? subcategoriesData : []);
      } catch (error) {
        setErrorMatrices(error.message); // Usar o estado específico para matrices
      } finally {
        setIsLoadingMatrices(false); // Usar o estado específico para matrices
      }
    };

    fetchMatricesAndRelatedData();
  }, [id]);

  useEffect(() => {
    const fetchSubEntitiesAndInvestigationGroups = async () => {
      if (!id) return; // Verifica se o ID da entidade está disponível
  
      // Busca as subentidades
      setIsLoadingSubEntities(true);
      setErrorSubEntities(null);
  
      try {
        const subEntitiesResponse = await fetch(`https://api.hub4food.colab4food.com/api/sub-entities/entity/${id}`);
        if (!subEntitiesResponse.ok) {
          if (subEntitiesResponse.status === 404) {
            setSubEntities([]); // Define subentidades como vazio
            setErrorSubEntities("Nenhuma subentidade encontrada."); // Mensagem específica para subentidades
          } else {
            throw new Error('Erro ao buscar as subentidades');
          }
        } else {
          const subEntitiesData = await subEntitiesResponse.json();
          setSubEntities(Array.isArray(subEntitiesData) ? subEntitiesData : []);
        }
      } catch (error) {
        setErrorSubEntities(error.message); // Usar o estado específico para subentidades
      } finally {
        setIsLoadingSubEntities(false); // Usar o estado específico para subentidades
      }
  
      // Busca os grupos de investigação
      setIsLoadingInvestigationGroups(true);
      setErrorInvestigationGroups(null);
  
      try {
        const investigationGroupsResponse = await fetch(`https://api.hub4food.colab4food.com/api/investigation-groups/entity/${id}`);
        if (!investigationGroupsResponse.ok) {
          if (investigationGroupsResponse.status === 404) {
            setInvestigationGroups([]); // Define grupos de investigação acomo vazio
            setErrorInvestigationGroups("Nenhum grupo de investigação encontrado."); // Mensagem específica para grupos de investigação
          } else {
            throw new Error('Erro ao buscar os grupos de investigação');
          }
        } else {
          const investigationGroupsData = await investigationGroupsResponse.json();
          setInvestigationGroups(Array.isArray(investigationGroupsData) ? investigationGroupsData : []);
        }
      } catch (error) {
        setErrorInvestigationGroups(error.message); // Usar o estado específico para grupos de investigação
      } finally {
        setIsLoadingInvestigationGroups(false); // Usar o estado específico para grupos de investigação
      }
    };
  
    fetchSubEntitiesAndInvestigationGroups();
  }, [id]); // O useEffect depende do id, logo será chamado sempre que o id mudar

  if (!entity) {
    return <CircularProgress />; // Exibe um spinner enquanto os dados são carregados
  }

  const handleFilter = (categoryName) => {
    if (activeFilter === categoryName) {
      // Se o filtro já estiver ativo, remove o filtro
      setFilteredEquipments(equipments);
      setActiveFilter(null);
    } else {
      // Aplica o filtro
      const filtered = equipments.filter(
        (equipment) => categoriesMap[equipment.category_id] === categoryName
      );
      setFilteredEquipments(filtered);
      setActiveFilter(categoryName);
    }
  };


  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Navbar */}
      <BurgerBar />

      {/* Main Content */}
      <Box sx={{ p: 3, maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
        <img 
    src={entity.image_path ? `https://api.hub4food.colab4food.com/${entity.image_path}` : '/logocolab.png'} 
    alt="Hub4Food Logo" 
    style={{ width: '80%', maxWidth: '120px' }} 
  />
 
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            <Typography variant="h5">{entity.name}</Typography>
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: '#3FA5D4' }}
            component="a"
            href={entity.website}
            target="_blank"
            rel="noopener noreferrer"
          >
            {entity.website}
          </Typography>

        </Box>

        {/* Tabs */}
        <Paper sx={{ mb: 3 }}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Entity" />
            <Tab label="Faculty" />
            <Tab label="Food Matrices" />
            <Tab label="Equipments" />
            <Tab label="R&I" />
            <Tab label="Patents" />
            <Tab label="Projects" />
          </Tabs>
        </Paper>

        {/* Entity Details */}
        {selectedTab === 0 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Head Office"
                  value={entity.head_office || ''} // Usa o campo head_office da entidade
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  value={entity.email_contact || ''} // Usa o campo email_contact da entidade
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Main Location"
                  value={entity.main_location || ''} // Usa o campo main_location da entidade
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Other Location"
                  value={entity.other_location || ''} // Usa o campo other_location da entidade
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Description"
                  value={entity.description || ''} // Usa o campo description da entidade
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  multiline
                  rows={5}
                />
              </Grid>
            </Grid>
          </Paper>
        )}

      {/* Faculty Details */}
{selectedTab === 1 && (
  <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
    {/* Tabela de Subentidades */}
    <Box sx={{ overflowX: 'auto', mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        SubEntity
      </Typography>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Name</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Contact</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Location</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                <CircularProgress />
              </td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd', color: 'red' }}>
                {error}
              </td>
            </tr>
          ) : subEntities.length > 0 ? (
            subEntities.map((subEntity) => (
              <tr key={subEntity.id}>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{subEntity.name}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{subEntity.contact || 'N.A'}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{subEntity.location || 'N.A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                No sub-entity found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>

    {/* Tabela de Grupos de Investigação */}
    <Box sx={{ overflowX: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Investigation Group
      </Typography>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Research Line</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Biography</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Description</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                <CircularProgress />
              </td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd', color: 'red' }}>
                {error}
              </td>
            </tr>
          ) : investigationGroups.length > 0 ? (
            investigationGroups.map((group) => (
              <tr key={group.id}>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{group.research_line}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{group.biography || 'N.A'}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{group.description || 'N.A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                Nenhum grupo de investigação encontrado.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  </Paper>
)}


        {/* Food Matrices Details */}
        {selectedTab === 2 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            {/* Botão "Expand All" */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: expandedAll ? 'red' : '#3FD461',
                  color: '#fff',
                }}
                onClick={toggleExpandAll}
              >
                {expandedAll ? 'Close All' : 'Expand All'}
              </Button>
            </Box>

            {/* Lista de matrizes */}
            <Box>
              {isLoading ? (
                <CircularProgress />
              ) : error ? (
                <Typography color="error">{error}</Typography>
              ) : matrices.length > 0 ? (
                matrices.map((matrix, index) => (
                  <Box key={matrix.id}>
                    {/* Cabeçalho da matriz */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid #ddd',
                        py: 1,
                        cursor: 'pointer',
                      }}
                      onClick={() => toggleExpandItem(index)}
                    >
                      <Typography variant="body1">{matrix.observations}</Typography>
                      <IconButton>
                        {expandedItems.includes(index) ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    </Box>

                    {/* Conteúdo expandido (categorias e subcategorias) */}
                    {expandedItems.includes(index) && (
                      <Box sx={{ paddingLeft: 2, color: '#555' }}>
                        {/* Lista de categorias */}
                        {matricesCategories
                          .filter((category) => category.matrice_id === matrix.id)
                          .map((category) => (
                            <Box key={category.id} sx={{ mt: 2 }}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                {category.description}
                              </Typography>

                              {/* Lista de subcategorias */}
                              {matricesSubcategories
                                .filter((subcategory) => subcategory.matrice_category_id === category.id)
                                .map((subcategory) => (
                                  <Typography key={subcategory.id} variant="body2" sx={{ ml: 2 }}>
                                    - {subcategory.description}
                                  </Typography>
                                ))}
                            </Box>
                          ))}
                      </Box>
                    )}
                    <Divider sx={{ my: 2 }} />
                  </Box>
                ))
              ) : (
                <Typography sx={{ textAlign: 'center', color: '#555', fontStyle: 'italic' }}>
                  There are no associated Food Matrices.
                </Typography>
              )}
            </Box>
          </Paper>
        )}

        {/* Equipments Details */}
        {selectedTab === 3 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            {/* Botões de filtro */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: activeFilter === 'Food Analysis' ? '#3FD461' : '#3FA5D4',
                  color: '#fff',
                  mr: 2,
                }}
                onClick={() => handleFilter('Food Analysis')}
              >
                Food Analysis
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: activeFilter === 'Food Technologies' ? '#3FD461' : '#3FA5D4',
                  color: '#fff',
                }}
                onClick={() => handleFilter('Food Technologies')}
              >
                Food Technologies
              </Button>
            </Box>

            {/* Searchbox */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <TextField
                label="Search Equipment"
                variant="outlined"
                fullWidth
                sx={{ maxWidth: '600px' }}
              />
            </Box>

            {/* Tabela de equipamentos */}
            <Box sx={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Entity | Location</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Category</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Equipment</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Main Specs</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                      <CircularProgress />
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd', color: 'red' }}>
                      {error}
                    </td>
                  </tr>
                ) : filteredEquipments.length > 0 ? (
                  filteredEquipments.map((equipment) => (
                    <tr key={equipment.id}>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {entitiesMap[equipment.entity_id] || 'N.A'}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {categoriesMap[equipment.category_id] || 'N.A'}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {equipment.equipment_name || 'N.A'}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {equipment.main_specs || 'N.A'}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                        <IconButton onClick={() => handleOpenEquipmentDetails(equipment)}>
                          <MoreHorizIcon />
                        </IconButton>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                        No equipment found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Box>
        </Paper>
        )}

        {/* Popup de Detalhes do Equipamento */}
        <Dialog open={openEquipmentDetails} onClose={handleCloseEquipmentDetails}>
  <DialogTitle>Equipments Details</DialogTitle>
  <DialogContent>
    {equipmentDetails ? (
      <Box>
        <Typography><strong>Entity:</strong> {equipmentDetails.entityName}</Typography>
        <Typography><strong>Category:</strong> {equipmentDetails.categoryName}</Typography>
        <Typography><strong>Matrice Observations:</strong> {equipmentDetails.matriceObservations}</Typography>
        <Typography><strong>Process Type:</strong> {equipmentDetails.processTypeName}</Typography>
        <Typography><strong>Equipment Name:</strong> {equipmentDetails.equipment_name}</Typography>
        <Typography><strong>Applications:</strong> {equipmentDetails.applications}</Typography>
        <Typography><strong>Observations:</strong> {equipmentDetails.observations}</Typography>
        <Typography><strong>Scales:</strong> {equipmentDetails.scales}</Typography>
        <Typography><strong>Main Specs:</strong> {equipmentDetails.main_specs}</Typography>
      </Box>
    ) : (
      <CircularProgress />
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseEquipmentDetails}>Fechar</Button>
  </DialogActions>
</Dialog>

        {/* R&I Details */}
        {selectedTab === 4 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            {/* Searchbox */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <TextField
                label="Search R&I"
                variant="outlined"
                fullWidth
                sx={{ maxWidth: '600px' }}
              />
            </Box>

            {/* Tabela de R&I */}
            <Box sx={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>Research Area & Field</th>
                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>Main Keywords</th>
                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>Research Topics</th>
                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>Specific Keywords</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                        <CircularProgress />
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd', color: 'red' }}>
                        {error}
                      </td>
                    </tr>
                  ) : skills.length > 0 ? (
                    skills.map((skill) => (
                      <tr key={skill.id}>
                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                          {researchAreas[skill.research_areas_field_id] || 'N.A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                          {skill.main_keywords || 'N.A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                          {skill.research_topics || 'N.A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                          {skill.specific_keywords || 'N.A'}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <Typography sx={{ textAlign: 'center', color: '#555', fontStyle: 'italic' }}>
                        Nenhuma skill encontrada.
                      </Typography>
                    </tr>
                  )}
                </tbody>
              </table>
            </Box>
          </Paper>
        )}

        {/* Patents Details */}
        {selectedTab === 5 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            {/* Searchbox */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <TextField
                label="Search Patents"
                variant="outlined"
                fullWidth
                sx={{ maxWidth: '600px' }}
              />
            </Box>

            {/* Tabela de patentes */}
            <Box sx={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Publication Number</th>
                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Title</th>
                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Publication Date</th>
                  </tr>
                </thead>
                <tbody>
                  {patents.length > 0 ? (
                    patents.map((patent) => (
                      <tr key={patent.id}>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{patent.publication_number}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{patent.title}</td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{patent.publication_date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                        Nenhuma patente encontrada.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Box>
          </Paper>
        )}

        {/* Projects Details */}
        {selectedTab === 6 && (
  <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
    {/* Tabela dinâmica */}
    <Box sx={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Acronym | Link</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Project Name</th>
            <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                <CircularProgress />
              </td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd', color: 'red' }}>
                {error}
              </td>
            </tr>
          ) : projects.length > 0 ? (
            projects.map((project) => (
              <tr key={project.id}>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {/* Exibe o acrônimo como um link clicável */}
                  <a
                    href={project.link} // Usa o link do projeto
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: '#3FA5D4' }}
                  >
                    {project.acronym || project.project_acronimo || 'N.A'} {/* Usa o campo correto */}
                  </a>
                </td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>{project.project_name}</td>
                <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                  <PendingIcon style={{ color: '#FFC107' }} />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd' }}>
                Nenhum projeto encontrado.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  </Paper>
)}

        {/* Outros detalhes das outras secções */}
      </Box>

      {/* Footer Moderno */}

      <Box sx={{ backgroundColor: '#2e2e2e', color: 'white', py: 4, mt: 4 }}>
  <Container maxWidth="lg">
    <Grid container spacing={4} justifyContent="center">
      {/* Sponsors Section on the Left */}
      <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
        This project is co-financed by:
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
          {/* 5 imagens da pasta public */}
          <img src="/prr.png" alt="Sponsor 1" style={{ width: '120px', height: '50px' }} />
          <img src="/rp.png" alt="Sponsor 2" style={{ width: '120px', height: '50px' }} />
          <img src="/NextGenerationEU_logo.png" alt="Sponsor 3" style={{ width: '120px', height: '40px' }} />
          <img src="/ani.png" alt="Sponsor 4" style={{ width: '120px', height: '40px' }} />
          <img src="/MissaoInterface_LOGO.png" alt="Sponsor 5" style={{ width: '120px', height: '40px' }} />
        </Box>
      </Grid>

      {/* Follow Us Section on the Right */}
      <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Follow Us!
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
  <IconButton
    href="https://www.facebook.com/colab4food"
    color="inherit"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FacebookIcon />
  </IconButton>
  <IconButton
    href="https://www.instagram.com/colab4food/"
    color="inherit"
    target="_blank"
    rel="noopener noreferrer"
  >
    <InstagramIcon />
  </IconButton>
  <IconButton
    href="https://www.linkedin.com/company/colab4food/"
    color="inherit"
    target="_blank"
    rel="noopener noreferrer"
  >
    <LinkedInIcon />
  </IconButton>
</Box>


        {/* Botão "Get in Loop" abaixo dos ícones em Follow Us */}
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<MailIcon />}
            href="/contacts" 
            sx={{
              backgroundColor: '#ff4081', 
              '&:hover': {
                backgroundColor: '#e1005e', 
              },
            }}
          >
            Contact Us
          </Button>
        </Box>
      </Grid>
    </Grid>

    {/* Linha horizontal separando as seções */}
    <Divider sx={{ my: 4, backgroundColor: '#ffffff' }} />  {/* Adiciona a linha */}

    {/* Espaço maior entre as seções */}
    <Box sx={{ mt: 6, textAlign: 'center' }}>
      <Typography variant="body2" color="inherit" align="center">
        Proprietary Platform - Copyright 2025 © by Colab4Food. Hub4Food<sup>® </sup> and Colab4Food<sup>® </sup> are registered trademarks. All rights reserved.
      </Typography>
      {/* Links para as políticas */}
      <Typography variant="body2" color="inherit" align="center" sx={{ mt: 2 }}>
        <Link href="/privacy-policy" color="inherit" sx={{ mx: 1 }}>
          Privacy Policy
        </Link>
        |
        <Link href="/terms-conditions" color="inherit" sx={{ mx: 1 }}>
          Terms & Conditions
        </Link>
        |
        <Link href="/accessibility-statement" color="inherit" sx={{ mx: 1 }}>
          Accessibility Statement
        </Link>
      </Typography>
    </Box>
  </Container>
</Box>

    </Box>
  );
}
